import { useLoggedInUserIsSuperUserOrHasFunctionClaim } from './useLoggedInUserIsSuperUserOrHasFunctionClaim';

export function useLoggedInUserIsSuperUserOrHasVeppFunctionalClaim(): boolean {
	return useLoggedInUserIsSuperUserOrHasFunctionClaim('vepp');
}
